import * as React from 'react';
import { BillingView } from '@/features/billing/components/BillingView';

export const CreditsView: React.FC = () => <BillingView compact />;
